export type StarOfTheCraftersHeadingType = {
  img: Record<string, string>
  title: Record<string, string>
  subtitle: Record<string, string>
  description: Record<string, string>
}

export type StarOfTheCraftersBodyType = {
  title: Record<string, string>
  items: StarOfTheCraftersBodyItemsType[]
}

export type StarOfTheCraftersBodyItemsType = {
  img: Record<string, string>
  title: Record<string, string>
  description: Record<string, string>
}

export const starsOfCraftersHeadingData: StarOfTheCraftersHeadingType[] = [
  {
    img: {
      black: '/img/blocks/star_of_the_crafters/hviezda_back.png',
      white: '/img/blocks/star_of_the_crafters/hviezda_white.png',
      colored: '/img/blocks/star_of_the_crafters/hviezda_colored.png',
    },
    title: {
      en: 'We are proud holders of the Brewers Star 2024',
      cs: 'Jsme hrdí držitelé hvězdy sládků 2024',
      sk: 'Sme hrdými držiteľmi hviezdy sládkov 2024',
    },
    subtitle: {
      en: 'Award for the best care given to draft beer',
      cs: 'Ocenění za nejlepší péčI o čepované pivo',
      sk: 'Ocenenia za najlepšiu starostlivosť o čapované pivo',
    },
    description: {
      en: 'The Brewers‘ Star is an award for pubs and restaurants which offer the best beer experience. It is awarded by Plzeňský Prazdroj for one calendar year and represents a guarantee of top quality. Only the best pubs and restaurants can get it for the perfect care they give to beer and its correct tapping.',
      cs: 'Hvězda sládků je ocenění hospod, které nabízejí nejlepší pivní zážitek. Uděluje ji Plzeňský Prazdroj na jeden kalendářní rok a je garantem špičkové kvality. Dostat ji mohou opravdu jen ty nejlepší hospody a restaurace za perfektní péči o pivo a správné čepování.',
      sk: 'Hviezda sládkov je ocenenie prevádzok, ktoré ponúkajú ten najlepší pivný zážitok. Udeľuje ju Plzeňský Prazdroj na jeden kalendárny rok a je garanciou špičkovej kvality. Dostať ju môžu naozaj len tie najlepšie krčmy a reštaurácie za perfektnú starostlivosť o pivo a správne čapovanie.',
    },
  },
]

export const starsOfCraftersBodyItemsData: StarOfTheCraftersBodyType[] = [
  {
    title: {
      en: 'Take a quick test for yourselves',
      cs: 'Udělejte si sami rychlý test',
      sk: 'Urobte si sami rýchly test',
    },
    items: [
      {
        img: {
          black: '/img/blocks/star_of_the_crafters/items/black/1.png',
          white: '/img/blocks/star_of_the_crafters/items/white/1.png',
          colored: '/img/blocks/star_of_the_crafters/items/colored/1.png',
        },
        title: {
          en: 'Cool and wet glass',
          cs: 'Chladné a mokré sklo',
          sk: 'Chladný a mokrý pohár',
        },
        description: {
          en: 'Beer must be poured into a cool and rinsed glass,only then will it have the right taste. Even the handle of the beer mug must be chilled.',
          cs: 'Pivo musí být načepované do chladné a opláchnut sklenice, jen v ní má správnou chuť. Chladné musí být i ucho půllitru.',
          sk: 'Pivo musí byť načapované do chladného a opláchnutého pohára, iba v ňom má tú správnu chuť. Chladné musí byť aj ucho pollitrového pohára.',
        },
      },
      {
        img: {
          black: '/img/blocks/star_of_the_crafters/items/black/2.png',
          white: '/img/blocks/star_of_the_crafters/items/white/2.png',
          colored: '/img/blocks/star_of_the_crafters/items/colored/2.png',
        },
        title: {
          en: 'Thick and creamy head without bubbles',
          cs: 'Hustá a krémová pěna bez bublin',
          sk: 'Hustá a krémová pena bez bublín',
        },
        description: {
          en: 'The primary indicator that a publican can tap beer correctly.',
          cs: 'Základní ukazatel toho, že hostinský umí pivo dobře načepovat.',
          sk: 'Základný ukazovateľ toho, že krčmár vie pivo dobre načapovať.',
        },
      },
      {
        img: {
          black: '/img/blocks/star_of_the_crafters/items/black/3.png',
          white: '/img/blocks/star_of_the_crafters/items/white/3.png',
          colored: '/img/blocks/star_of_the_crafters/items/colored/3.png',
        },
        title: {
          en: 'Beer leaves rings',
          cs: 'Pivo kroužkuje',
          sk: 'Pivo krúžkuje',
        },
        description: {
          en: 'After drinking, beer leaves typical traces in the form of rings inside the glass. This is proof that the glass is perfectly clean.',
          cs: 'Po napití zanechává pivo na skle stopy v podobě charakteristických kroužků. Je to důkaz, že je sklenice dokonale čistá.',
          sk: 'Po odpití zanecháva pivo na pohári stopy v podobe charakteristických krúžkov. Je to dôkaz toho, že je pohár dokonale čistý.',
        },
      },
      {
        img: {
          black: '/img/blocks/star_of_the_crafters/items/black/4.png',
          white: '/img/blocks/star_of_the_crafters/items/white/4.png',
          colored: '/img/blocks/star_of_the_crafters/items/colored/4.png',
        },
        title: {
          en: 'The right taste',
          cs: 'Ta správná chuť',
          sk: 'Tá správna chuť',
        },
        description: {
          en: 'Only beer stored in a cool place and dispensed using the correct gas has the right taste. Cleaning beer pipes and the bar is equally important. And of course, the correct pouring style.',
          cs: 'Správnou chuť má jen pivo skladované v chladu a tlačené správným plynem. Stejně důležité je pravidelně čištěné pivní vedení a výčepní pult. A samozřejmě správný styl čepování.',
          sk: 'Správnu chuť má iba pivo skladované v chlade a tlačené správnym plynom. Rovnako dôležité je pravidelné čistenie pivného vedenia a výčapného pultu. A samozrejme správny štýl čapovania.',
        },
      },
    ],
  },
]
